import type { CatequistaDto } from '@sheepcount/shared';

const TOKEN_KEY = 'sheepcount.token';
const CATEQUISTA_KEY = 'sheepcount.catequista';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getCatequista(): CatequistaDto | null {
  const raw = localStorage.getItem(CATEQUISTA_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<CatequistaDto> | null;
    if (!parsed || typeof parsed !== 'object' || typeof parsed.id !== 'string') return null;
    // Sessões antigas podem não ter `role`: trata como não-admin (o /auth/me reidrata).
    return { role: 'CATEQUISTA', ...parsed } as CatequistaDto;
  } catch {
    return null;
  }
}

export function saveSession(token: string, catequista: CatequistaDto): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(CATEQUISTA_KEY, JSON.stringify(catequista));
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(CATEQUISTA_KEY);
}
